import styled from "@emotion/styled";
import Colors from "/styles/colors";
export const StyledPillComponent = styled.div`
  display: inline-block;
  text-align: center;
  transition: background-color 0.3s ease, opacity 0.3s ease;
  border-style: solid;

  background-color: ${(props)=>Colors[props.backgroundColor]};
  border-width: ${(props)=>props.borderThickness};
  border-color: ${(props)=>Colors[props.borderColor]};
  border-radius: ${(props)=>props.borderRadius};
  color: ${(props)=>Colors[props.textColor]};
  font-size: ${(props)=>props.fontSize};
  padding: ${(props)=>props.padding};
  margin: ${(props)=>props.margin};

  &:hover {
    opacity: ${(props)=>props.hoverOpacity};
  }
`;
